module.exports = __webpack_public_path__ + "img/3.7daf66e7.jpg";